import { useState, useEffect, useRef } from "react";
import { SandboxOutputLine } from "./OutputTypes";

const useOutputInternal = (replUrl: string | null) => {
  const [outputLines, setOutputLines] = useState<SandboxOutputLine[]>([]);
  const sourceRef = useRef<EventSource | null>(null);

  useEffect(() => {
    if (!replUrl) {
      return;
    }

    // Create EventSource on mount
    sourceRef.current = new EventSource(`${replUrl}/repl/eval`, { withCredentials: true });

    // Cleanup: close EventSource on unmount
    return () => {
      if (sourceRef.current) {
        sourceRef.current.close();
      }
    };
  }, [replUrl]);

  // Attach message listener
  useEffect(() => {
    if (!sourceRef.current) {
      return;
    }

    const onMessage = (event: MessageEvent) => {
      const data = JSON.parse(event.data) as { output: string; error?: boolean };
      if (typeof data.output === "string") {
        for (const line of data.output.split("\n")) {
          if (line.trim() === "") {
            continue;
          }
          setOutputLines(prev => [
            ...prev,
            {
              id: (prev.length > 0 ? parseInt(prev[prev.length - 1].id) + 1 : 1).toString(),
              timestamp: new Date(),
              text: line,
            },
          ]);
        }
      }
    };

    sourceRef.current.addEventListener("repl-errors", onMessage);

    return () => {
      if (sourceRef.current) {
        sourceRef.current.removeEventListener("repl-errors", onMessage);
      }
    };
  }, [sourceRef.current]);

  return outputLines;
};

export default useOutputInternal;
